
import { a11yProps, sizeTab } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableSolucionSolicitudCanje from "../../shared/TableSolucionSolicitudCanje";
import TableSolucionSolicitudEvento from "../../shared/TableSolucionSolicitudEvento";

export default function SolucionEventoCanjePage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title="Solución Solicitud Evento/Canje"
      py={2}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Canjes'} {...a11yProps(0)} />
          <Tab label={'Eventos'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolucionSolicitudCanje />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolucionSolicitudEvento />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );

}

